import { Component, OnInit, OnDestroy } from '@angular/core';

import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { RoleService } from 'src/app/core/services/role.service';
import { Router, RouterModule } from '@angular/router';
import { Role } from '@models/enums';
import { Subject, takeUntil } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';

interface NavLink {
  label: string;
  route: string;
  visible: boolean;
}

@Component({
    selector: 'app-body',
    imports: [MatTabsModule, RouterModule, MatIconModule],
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss']
})
export class BodyComponent implements OnInit, OnDestroy {
  accessProfile: any;
  userRoles: Role[] = [];
  token: string | null | undefined;
  private readonly destroy$ = new Subject<void>();
  totalDemandeAvis: number = 0;

  navLinks: NavLink[] = [
    { label: 'ACCUEIL', route: 'pama', visible: true },
    { label: 'RECRUTEMENT', route: 'pama/recrutement', visible: false },
    { label: 'RENOUVELLEMENT', route: 'pama/renouvellement', visible: false },
    { label: 'CONSULTATION DES DEMANDES', route: 'pama/consultation', visible: false },
    { label: 'VALIDATION DES DEMANDES', route: 'pama/validation-demandes', visible: false },
    { label: 'CONSULTATION FIN DE CONTRATS', route: 'pama/consultation-fin-contrats', visible: true },
    { label: 'CONSULTATION ANNUAIRE DES POSTES', route: 'pama/consultation-annuaire-poste', visible: true },
    { label: "DEMANDES D'AVIS", route: 'pama/demande-avis-list', visible: true },
    { label: 'ADMINISTRATION', route: 'pama/administration', visible: true }
  ];

  constructor(
    private readonly roleService: RoleService,
    private readonly router: Router,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.roleService
      .getRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        this.userRoles = roles as Role[];
        this.updateVisibleLinks();
      });

    this.notificationService.validationCounts$.pipe(takeUntil(this.destroy$)).subscribe((counts) => {
      this.totalDemandeAvis = counts?.totalDemandeAvis ?? 0;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateVisibleLinks(): void {
    this.navLinks = this.navLinks.map((link) => ({
      ...link,
      visible: this.roleService.canAccessLink(link.label)
    }));
  }

  /**
   * Custom method to check if a route is active, ignoring query parameters
   * @param route The route to check
   * @returns True if the current URL matches the route path
   */
  isRouteActive(route: string): boolean {
    // Get current URL without query parameters
    const currentUrl = this.router.url.split('?')[0];

    // Create the route path to match against (adding '/' prefix)
    const routePath = '/' + route;

    // For the root path 'pama', check for exact match
    if (route === 'pama') {
      return currentUrl === routePath;
    }

    // For routes like consultation and consultation-fin-contrats,
    // we need to ensure we don't get false positives from partial matches
    // Check if URL exactly matches or if it's followed by a slash or nothing
    const isExactMatch = currentUrl === routePath;
    const isChildRoute = currentUrl.startsWith(routePath + '/');

    return isExactMatch || isChildRoute;
  }
}
